<template>
    <div class="col-sm-12">
        <div style="display: flex; flex-direction: column">
            <div style="display: flex; justify-content: space-between">
                <h2>Scraped Companies USDOT</h2>
                <div>
                    <a class="btn btn-danger is-aligned-right" :href="url(`/admin/prospects/list`)">
                        <span class="glyphicon glyphicon-chevron-left" aria-hidden="true"></span> Go to Prospects
                    </a>
                </div>
            </div>

            <div v-if="ready">
                <div class="filter-group list-filter" style="display: flex; flex-wrap: wrap;">
                    <div class="form-group">
                        <label>Company name</label>
                        <input type="text" class="form-control" v-model="filter.search" v-on:keyup.enter="refresh">
                    </div>
                    <div class="form-group">
                        <label>USDOT</label>
                        <input type="text" class="form-control" v-model="filter.usdot" v-on:keyup.enter="refresh">
                    </div>
                    <div class="form-group" style="width: 250px">
                        <label>USDOT state</label>
                        <el-select
                            v-model="filter.states"
                            multiple
                            collapse-tags
                            placeholder="Select"
                            style="width: 100%"
                        >
                            <el-option
                                v-for="item in lists.states"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value">
                            </el-option>
                        </el-select>
                    </div>
                    <!-- <div class="form-group">
                        <label>Min Craigslist Posts</label>
                        <input type="number" class="form-control" v-model="filter.craigslist_posts">
                    </div> -->
                    <div class="form-group">
                        <label>Min Indeed Posts</label>
                        <input type="number" class="form-control" v-model="filter.indeed_posts">
                    </div>
                    <div class="form-group">
                        <label>Min Indeed Reviews</label>
                        <input type="number" class="form-control" v-model="filter.indeed_reviews">
                    </div>
                    <div class="form-group">
                        <label>Scraped between</label>
                        <el-date-picker
                            v-model="filter.created_from"
                            type="date"
                            format="M/d/yyyy"
                            value-format="yyyy-MM-dd"
                            placeholder="From"
                            style="width: 100%"
                        >
                        </el-date-picker>
                    </div>
                    <div class="form-group">
                        <label>&nbsp;</label>
                        <el-date-picker
                            v-model="filter.created_to"
                            type="date"
                            format="M/d/yyyy"
                            value-format="yyyy-MM-dd"
                            placeholder="To"
                            style="width: 100%"
                        >
                        </el-date-picker>
                    </div>
                    <div class="form-group" style="padding-top: 25px">
                        <btn cssClass="btn btn-secondary" icon="fas fa-redo-alt" :click="refresh">Filter</btn>
                    </div>
                </div>
            </div>

            <table class="table table-striped table-hover table-sticky-header custom-table" v-loading="loading">
                <thead>
                    <tr>
                        <th>ID</th>
                        <th>Scraped Company</th>
                        <th>Assigned USDOT</th>
                        <th style="width: 600px">Assign USDOT</th>
                        <!-- <th>Craigslist</th> -->
                        <th>Indeed</th>
                        <th>Reviews</th>
                        <th>Email</th>
                        <th>Links</th>
                    </tr>
                </thead>
                <tbody>
                    <prospect-usdots-row 
                        :row="row" 
                        v-for="row in rows" 
                        :key="row.id"
                        @refresh="refresh"
                    />
                </tbody>
            </table>
            
            <div class="row" v-if="pagination.total > 0">
                <div class="col-sm-12 text-center">
                    <el-pagination 
                        layout="prev, pager, next"
                        background
                        v-bind:current-page.sync="pagination.page"
                        @current-change="changePage"
                        :page-size="pagination.perPage"
                        :total="pagination.total"
                    />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import ProspectUsdotsRow from "./prospect-usdots-row";

export default {
    components: {
        ProspectUsdotsRow
    },
    data() {
        return {
            filter: {
                search: '',
                usdot: '',
                craigslist_posts: null,
                indeed_posts: null,
                indeed_reviews: null,
                states: [],
                created_from: null,
                created_to: null,
                page: 1
            },
            rows: [],
            lists: [],
            pagination: {
                page: 1,
                perPage: 100,
                total: 0
            },
            ready: false,
            loading: true
        };
    },
    methods: {
        refresh() {
            this.loading = true;

            return axios.post(url(`admin/prospects/usdots/data`), this.filter)
                .then((response) => {
                    this.rows = response.data.rows;
                    this.pagination = response.data.pagination;
                    this.lists = response.data.lists;

                    this.loading = false;
                    this.ready = true;
                });
        },
        changePage(page) {
            this.filter.page = page;
            this.refresh();
        },
        
    },
    mounted() {
        this.refresh();
    }
}
</script>